import { saveAs } from 'file-saver';

export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    exportExcel(res, name) {
      const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
      saveAs(blob, name);
    },
  },
};
